import React, { FC } from 'react';
import { LinkProps } from 'react-router-dom';
import { Anchor } from './styles';

const AnchorComponent: FC<LinkProps> = (
  { children, ...props },
) => <Anchor {...props}>{children}</Anchor>;

export default AnchorComponent;
